import { DefaultOptions } from "@tanstack/react-query";

/*
 * A single global instance of the React QueryClient.
 */
export const queryConfig = {
  queries: {
    retry: 2, // Retry failed queries up to 2 times
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  },
} satisfies DefaultOptions;
